module.exports = __webpack_public_path__ + "media/bip.a3acd77d.wav";